module.exports = __webpack_public_path__ + "img/shipo-icon-personal-card.b3ca800b.svg";